import { Text, Stack, Circle, Divider } from '@chakra-ui/react';
import { djs } from '@duke-hq/djs';

const displayFields = [
  'unit_title',
  'unit_code',
  'resource_title',
  'course_code',
  'course_title',
] as const;

const fieldLabels: Record<(typeof displayFields)[number], string> = {
  unit_title: 'Unit Title',
  unit_code: 'Unit Code',
  resource_title: 'Resource Title',
  course_code: 'Course Code',
  course_title: 'Course Title',
};

export type ActivityItemData = {
  [K in (typeof displayFields)[number]]?: string;
};

export interface ActivityItem {
  msg: string;
  pk: string;
  sk: string;
  data: ActivityItemData;
}

export function UserAppEvents({
  studentActivityItems = [],
}: {
  studentActivityItems: ActivityItem[];
}) {
  return (
    <Stack spacing="0" fontSize="sm">
      {studentActivityItems.map((studentActivityItem, index) => (
        <Stack
          spacing="4"
          direction="row"
          key={`${studentActivityItem.pk}-${studentActivityItem.sk}`}
        >
          <Stack spacing="0" align="center">
            <Circle size="3" bg={'gray.400'}></Circle>
            <Divider
              orientation="vertical"
              borderWidth="1px"
              borderColor={studentActivityItems.length === index + 1 ? 'transparent' : 'gray.400'}
            />
          </Stack>
          <Stack spacing="0.5" pb={studentActivityItems.length === index + 1 ? '0' : '8'}>
            <Text color="fg.emphasized" fontWeight="semibold">
              {studentActivityItem.msg}
            </Text>
            <Text color="fg.subtle" fontSize="xs">
              {djs(studentActivityItem.sk).format('LLL')}
            </Text>
            <RenderDataFields data={studentActivityItem.data} />
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}

function RenderDataFields({ data }: { data: ActivityItemData }) {
  const fields: React.ReactElement[] = [];

  for (const key of displayFields) {
    const value = data[key];
    if (typeof value !== 'string') {
      continue;
    }

    fields.push(
      <Text key={key} color="fg.muted" fontSize="xs">
        <strong>{fieldLabels[key]}:</strong>
        &nbsp;
        {value}
      </Text>,
    );
  }

  return fields;
}
